import React, {useState} from 'react';
import { useHistory } from 'react-router-dom';
import logo from '../assets/logo-dark.png';
import plans from 'config/plans';
import { useAuth, updateCompany } from 'api';
import { 
  Title,
  Text,
  Button,
  Notice,
} from 'ui';
import './index.css';

export default function Plan(props) {
  
  const auth = useAuth();
  const history = useHistory();
  const [error, setError] = useState("");
  
  if(!auth) {
    return null;
  }
  
  console.log(auth);
  
  if(!auth.company.id) {
    return <Notice text="No company found."/>;
  }
  
  async function selectPlan(plan) {
    try {
      await updateCompany(auth.company.id, {plan});
    }
    catch(error) {
      setError(error.message);
      return;
    }
    
    history.push("/");
  }
  
  async function selectMonthly(plan) {
    plan.id = plan.monthlyId;
    return selectPlan(plan);
  }
  
  async function selectAnnual(plan) {
    plan.id = plan.yearlyId;
    return selectPlan(plan);
  }
  
  
  return (
    <div className="auth-screen">
      <img src={logo} alt="Taptivate" className="auth-logo"/>
      
      <Title className="auth-title">Monthly subscriptions for all<br/>business sizes</Title>
      <Text>Comes with a 30 day free trial. Cancel any time.</Text>
      
      <Text color="red" className="auth-error">{error || ""}</Text>
      
      <div className="auth-3col">
        {plans.map(plan => 
          <div className="auth-card" key={plan.id}>
            <Title>
              {plan.name}<br/>
              ${plan.cost/100}/month
            </Title>
            <ul>
              {plan.features.map((feature, i) => 
                <li key={i}><Text small>{feature}</Text></li>
              )}
            </ul>
            <Text bold block style={{padding:"16px 0 32px 0"}}>Save 10% by billing annually</Text>
            <Button className="auth-button" onClick={() => selectMonthly(plan)} style={{maxWidth:'none', marginTop:8, marginBottom:8}}>PAY MONTHLY</Button>
            <Button className="auth-button" onClick={() => selectAnnual(plan)} style={{maxWidth:'none', marginTop:8, marginBottom:8}}>PAY ANNUALLY</Button>
          </div>
        )}
      </div>
      
      <Title block>Custom Enterprise &ndash;</Title>
      <a href="mailto:info@taptivate.co" style={{display:'block', textDecoration:'none'}}>
        <Text block small>
          Your national or global enterprise has a highly specific set of requirements.<br/>
          Please email us at <Text small orange>info@taptivate.co</Text> to discuss your needs.
        </Text>
      </a>
      
    </div>
  );
}